import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-not-found',
  templateUrl: './request-not-found.component.html',
  styleUrls: ['./request-not-found.component.css']
})
export class RequestNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
